import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useCurrentSessionUser } from '../session';

type UseIsInformationBarrierEnabled = () => boolean;
export const useIsInformationBarrierEnabled: UseIsInformationBarrierEnabled = () => {
  const { isNetworkAdmin, isVerifiedNetworkAdmin } = useCurrentSessionUser();

  const isInformationBarrierEnabled = useExperimentTreatmentWithoutReporting('InformationBarriersPhase0') === true;
  const isVivaEngagePremium = useExperimentTreatmentWithoutReporting('VivaEngagePremium') === true;

  return isInformationBarrierEnabled && isVivaEngagePremium && isNetworkAdmin && isVerifiedNetworkAdmin;
};
